import { render, staticRenderFns } from "./custab.vue?vue&type=template&id=e77fec94&scoped=true"
import script from "./custab.vue?vue&type=script&lang=js"
export * from "./custab.vue?vue&type=script&lang=js"
import style0 from "./custab.vue?vue&type=style&index=0&id=e77fec94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77fec94",
  null
  
)

export default component.exports